import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output,
} from '@angular/core';
import {
  CacheConfigToggleListSummary,
  DynamicFormCustomEvent,
} from '../dynamic-field-type/dynamic-field-type.component';

@Component({
    selector: 'lockton-apps-dynamic-form-card',
    templateUrl: './dynamic-form-card.component.html',
    styleUrls: ['./dynamic-form-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DynamicFormCardComponent {
  @HostBinding('class.dynamic-form-card--invalid') @Input() invalid!: boolean;
  @HostBinding('class.dynamic-form-card--alt') @Input() alt!: boolean;
  @HostBinding('class.dynamic-form-card--expansion')
  @Input()
  withinExpansion!: boolean;

  @Input() item!: any;
  @Input() name!: string;
  @Input() readonly!: boolean | undefined;
  @Input() summary!: CacheConfigToggleListSummary | undefined;
  @Input() distinctBy!: string | undefined;
  @Input() distinctToggleListBy!: string | undefined;
  @Input() fields!: any[];
  @Output() edit: EventEmitter<void> = new EventEmitter();
  @Output() delete: EventEmitter<void> = new EventEmitter();

  @Output() customEvent = new EventEmitter<DynamicFormCustomEvent>();
}
